import { datadogRum } from '@datadog/browser-rum';
import { captureException } from '@sentry/vue';
import type { User } from '@teemill/dashboard-user';

import { defineStore } from 'pinia';
import type { RouteLocationRaw } from 'vue-router';

interface State {
  ready: boolean;
  user?: User;
  token?: string;
  redirect?: RouteLocationRaw;
}

export const useUserStore = defineStore('user', {
  state: (): State => ({
    ready: false,
    user: undefined,
    token: undefined,
    redirect: undefined,
  }),

  getters: {
    active(): User | undefined {
      return this.user;
    },
    features(): string[] {
      return this.user?.features || [];
    },
  },

  actions: {
    update(user: User | string | undefined) {
      if (typeof user === 'string') {
        this.token = user;
      } else {
        this.user = user;

        try {
          if (this.user === undefined) {
            datadogRum.clearUser();
          } else {
            datadogRum.setUser({
              id: this.user.id.toString(),
              email: this.user.email,
              name: this.user.username || undefined,
              theme: window.localStorage.getItem('theme') || 'unknown',
            });
          }
        } catch (error) {
          captureException(error);
        }
      }

      this.ready = true;
    },

    updateRedirect(redirect?: RouteLocationRaw) {
      this.redirect = redirect;
    },
  },
});
